module.exports = __webpack_public_path__ + "static/media/right.e3993080.svg";